<template>
  <div
    class="fill-height doc-page"
    :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 0px; padding-top: 62px;` : `padding-bottom: 610px; padding-top: 64px;`">
    <v-dialog
      persistent
      scrollable
      v-if="dialog.filter"
      v-model="dialog.filter"
      width="450">
      <v-card class="filter-dialog">
        <div class="d-flex align-center px-5 py-4 filter-dialog__header">
          <v-icon size="16" :color="set_color" class="mr-2">mdi-tune-variant</v-icon>
          <div class="filter-dialog__title">
            Filter Data
          </div>
          <v-spacer />
          <v-btn
            width="32"
            height="32"
            elevation="0"
            icon
            class="px-0"
            @click="dialog.filter = false;">
            <v-icon size="20" color="#8A8F98">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="pb-2 pt-4">
          <div class="mt-0">
            <v-autocomplete
              :items="category"
              :color="`${set_color}`"
              :item-color="`${set_color}`"
              hide-details
              class="mb-3"
              v-model="filter.jenis_bidang"
              item-text="name"
              item-value="slug"
              placeholder="Kategori"
              solo
              flat
            ></v-autocomplete>
            <v-select
              :items="category_bidang"
              :color="`${set_color}`"
              :item-color="`${set_color}`"
              hide-details
              class="mb-3"
              clearable
              v-model="filter.category_bidang"
              @click:clear="filter.category_bidang = ''"
              item-text="title"
              item-value="slug"
              placeholder="Kategori"
              solo
              flat
            ></v-select>

            <v-text-field
              solo
              flat
              hide-details
              clearable
              class="mb-3"
              v-model="filter.nomor"
              @click:clear="filter.nomor = ''"
              :color="`${set_color}`"
              :placeholder="`Nomor`">
            </v-text-field>

            <v-select
              :items="years"
              :color="`${set_color}`"
              :item-color="`${set_color}`"
              hide-details
              v-model="filter.tahun"
              clearable
              @click:clear="filter.tahun = ''"
              class="mb-3"
              item-text="name"
              item-value="id"
              placeholder="Tahun"
              solo
              flat
            ></v-select>

            <v-text-field
              solo
              flat
              hide-details
              clearable
              class="mb-1"
              v-model="filter.title"
              @click:clear="filter.title = ''"
              :color="`${set_color}`"
              :placeholder="`Nama`">
            </v-text-field>


            <div v-if="$route.query.jenis === 'peraturan-desa'">
              <v-select
                :items="kecamatan"
                :color="`${set_color}`"
                :item-color="`${set_color}`"
                hide-details
                clearable
                class="mb-3"
                @click:clear="filter.kecamatan = ''"
                item-text="title"
                item-value="title"
                v-on:change="changeKecamatan()"
                v-model="filter.kecamatan"
                placeholder="Kecamatan"
                solo
                flat
              ></v-select>

              <v-select
                :items="desa"
                :color="`${set_color}`"
                :item-color="`${set_color}`"
                hide-details
                clearable
                @click:clear="filter.desa = ''"
                :disabled="filter.kecamatan === '' || filter.kecamatan === null"
                class="mb-1"
                item-text="title"
                item-value="title"
                v-model="filter.desa"
                placeholder="Desa/Kelurahan"
                solo
                flat
              ></v-select>
            </div>

          </div>
        </v-card-text>
        <v-card-actions class="pa-4 pt-2">
          <v-btn
            elevation="0"
            :color="set_color"
            block
            height="46"
            @click="changeLinkPage(); dialog.filter = false;"
            class="text-capitalize font-weight-bold white--text filter-sidebar__btn">
            <v-icon size="18" class="mr-2">mdi-magnify</v-icon>
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-container>
            <v-row>
              <v-col cols="12" md="9">
                <div class="doc-header" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'mt-1' : ''">
                  <div class="doc-header__topline">
                    <div class="doc-header__eyebrow" :style="`color: ${set_color}`">Direktori Dokumen Hukum</div>
                    <button
                      v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'"
                      type="button"
                      class="doc-filter-trigger"
                      @click="dialog.filter = true">
                      <v-icon size="17" :color="set_color">mdi-tune-variant</v-icon>
                      <span>Filter</span>
                    </button>
                  </div>
                  <div class="doc-header__main">
                    <div class="doc-header__title-wrap">
                      <div class="doc-header__title" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'doc-header__title--lg' : 'doc-header__title--sm'">
                        {{ $route.query.jenis == 'semua-kategori' ? 'Semua dokumen' : ($route.query.jenis && $route.query.jenis.split ? ($route.query.jenis.split('-').join(' ')) : '') }}
                      </div>
                      <div class="doc-header__subtitle">
                        Temukan dokumen hukum berdasarkan kategori, bidang, nomor, atau tahun.
                      </div>
                    </div>
                    <div class="doc-header__meta" v-if="!process.load">
                      <div class="doc-header__count">{{ pagination.total_data }} dokumen</div>
                    </div>
                  </div>
                </div>
                <!-- <div>
                  <v-chip
                    class="ma-2"
                    close
                    v-if="dialog.filter === false && selected_filter.title === true && filter.title !== '' && filter.title !== null"
                    text-color="white"
                    :color="set_color"
                    @click:close="filter.title = ''; changeLinkPage()"
                    >
                    Judul: {{ filter.title }}
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    close
                    v-if="dialog.filter === false && selected_filter.tahun === true && filter.tahun !== '' && filter.tahun !== null"
                    text-color="white"
                    :color="set_color"
                    @click:close="filter.tahun = ''; changeLinkPage()"
                    >
                    Tahun: {{ filter.tahun }}
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    close
                    v-if="dialog.filter === false && selected_filter.nomor === true && filter.nomor !== '' && filter.nomor !== null"
                    text-color="white"
                    :color="set_color"
                    @click:close="filter.nomor = ''; changeLinkPage()"
                    >
                    Nomor: {{ filter.nomor }}
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    close
                    v-if="dialog.filter === false && selected_filter.kecamatan === true && filter.kecamatan !== '' && filter.kecamatan !== null"
                    text-color="white"
                    :color="set_color"
                    @click:close="filter.kecamatan = ''; changeLink()"
                    >
                    Kecamatan: {{ filter.kecamatan }}
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    close
                    v-if="dialog.filter === false && selected_filter.desa === true && filter.desa !== '' && filter.desa !== null"
                    text-color="white"
                    :color="set_color"
                    @click:close="filter.desa = ''; changeLink()"
                    >
                    Desa: {{ filter.desa }}
                  </v-chip>
                  <div class="mt-4 text-capitalize font-weight-medium" v-if="dialog.filter === false && selected_filter.category_bidang === true && filter.category_bidang !== '' && filter.category_bidang !== null">
                    <v-chip
                    class="ma-2"
                      close
                      text-color="white"
                      :color="set_color"
                      @click:close="filter.category_bidang = ''; changeLinkPage()"
                      >
                      Bidang: {{ (filter.category_bidang && filter.category_bidang.split ? filter.category_bidang.split('-').join(' ') : '') }}
                    </v-chip>
                  </div>
                </div> -->
                <!-- <div class="mb-3">
                  <v-text-field
                    solo
                    hide-details
                    clearable
                    v-model="search"
                    class="bg-input-white"
                    v-on:keyup.enter="changeLinkPage()"
                    @click:clear="search = ''; changeLinkPage();"
                    style="border-radius: 6px 0px 0px 6px !important;"
                    :color="`${set_color}`"
                    :placeholder="`Cari peraturan yang Anda butuhkan . . .`">
                    <template v-slot:prepend-inner>
                      <v-icon class="mr-2">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div> -->
                <div
                  v-for="(item, index) in process.load ? 6 : list"
                  :key="index"
                  class="doc-card">
                  <v-skeleton-loader
                    v-if="process.load"
                    type="list-item-two-line"
                    class="pa-2"
                  ></v-skeleton-loader>
                  <template v-else>
                    <div class="doc-card__row" @click="toDetail(item)" @mouseover="voiceHover(item.title)">
                      <div class="doc-card__icon" :style="`background: ${set_color}`">
                        <v-icon size="20" color="white">mdi-file-document-outline</v-icon>
                      </div>
                      <div class="doc-card__body">
                        <div class="doc-card__title-row">
                          <div class="doc-card__title">{{ item.title }}</div>
                          <v-chip
                            small
                            label
                            text-color="white"
                            class="doc-card__status font-weight-bold"
                            :color="item.status_option === 'Berlaku' ? '#1BAA5C' : item.status_option === 'Tidak Berlaku' ? '#E0355B' : item.status_option === 'Diubah' ? '#2E7DE1' : '#DB7F13'"
                          >
                            {{ item.status_option }}
                          </v-chip>
                        </div>
                        <div class="doc-card__meta">
                          <span class="doc-card__meta-item">
                            <v-icon size="13" color="#8A8F98">mdi-file-document</v-icon>
                            {{ item.doc_type_title }}
                          </span>
                          <span class="doc-card__meta-item">
                            <v-icon size="13" color="#8A8F98">mdi-map-marker</v-icon>
                            {{ item.lokasi }}
                          </span>
                          <span class="doc-card__meta-item" v-if="item.tag !== ''">
                            <v-icon size="13" color="#8A8F98">mdi-tag</v-icon>
                            {{ item.category_title }}
                          </span>
                          <span class="doc-card__meta-item">
                            <v-icon size="13" color="#8A8F98">mdi-calendar-range</v-icon>
                            {{ item.penetapan_date | date }}
                          </span>
                          <span class="doc-card__meta-item" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                            <v-icon size="13" color="#8A8F98">mdi-eye</v-icon>
                            {{ item.view_count }} dilihat
                          </span>
                          <span class="doc-card__meta-item" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                            <v-icon size="13" color="#8A8F98">mdi-download</v-icon>
                            {{ item.download_count }} diunduh
                          </span>
                        </div>
                        <div class="doc-card__meta" v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'">
                          <span class="doc-card__meta-item">
                            <v-icon size="13" color="#8A8F98">mdi-eye</v-icon>
                            {{ item.view_count }}
                          </span>
                          <span class="doc-card__meta-item">
                            <v-icon size="13" color="#8A8F98">mdi-download</v-icon>
                            {{ item.download_count }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="doc-card__actions">
                      <v-btn
                        v-if="item.abstrak !== '' || item.abstrak_file !== ''"
                        outlined
                        small
                        elevation="0"
                        color="#E0355B"
                        :loading="process.form"
                        :disabled="process.form"
                        @mouseover="voiceHover('Download Abstrak')"
                        @click="item.abstrak_file !== '' ? downloadFile(item.abstrak_file, getFile(item.abstrak_file).split('/')[5]) : download_abstrak(item)"
                        class="text-capitalize font-weight-medium doc-card__btn">
                        <v-icon size="16" class="mr-1">mdi-file-document-outline</v-icon>
                        Abstrak
                      </v-btn>
                      <v-btn
                        outlined
                        small
                        elevation="0"
                        color="#1BAA5C"
                        :disabled="item.file_url === ''"
                        @mouseover="voiceHover('Download')"
                        @click="download(item.id); downloadFile(item.file_url, getFile(item.file_url).split('/')[5])"
                        class="text-capitalize font-weight-medium doc-card__btn">
                        <v-icon size="16" class="mr-1">mdi-download</v-icon>
                        Unduh
                      </v-btn>
                      <v-btn
                        small
                        elevation="0"
                        :color="set_color"
                        @click="toDetail(item)"
                        @mouseover="voiceHover('Lihat Detail')"
                        class="text-capitalize font-weight-medium white--text doc-card__btn">
                        <v-icon size="16" class="mr-1">mdi-text-box-search-outline</v-icon>
                        Detail
                      </v-btn>
                    </div>
                  </template>
                </div>
                <div v-if="!process.load && pagination.total_data > 20 && limit < pagination.total_data"
                  class="text-center mt-4 mb-2">
                  <v-btn
                    @click="limit += 20"
                    :loading="process.limit"
                    small
                    rounded
                    outlined
                    elevation="0"
                    @mouseover="voiceHover('Lebih Banyak')"
                    :color="set_color"
                    class="text-capitalize"
                    style="opacity: 60%;">
                    Lebih banyak
                  </v-btn>
                </div>

                <Empty v-if="!process.load && list.length < 1"
                  class="py-12"
                  margin="my-16"
                  size="125"
                  message="" />
              </v-col>
              <v-col cols="12" md="3" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                <v-card flat class="filter-sidebar">
                  <v-card-text class="pa-5">
                    <div class="filter-sidebar__title">
                      <v-icon size="16" :color="set_color" class="mr-2">mdi-tune-variant</v-icon>
                      <span :style="`color: ${set_color}`">Filter Data</span>
                    </div>
                    <v-autocomplete
                      :items="category"
                      :color="`${set_color}`"
                      :item-color="`${set_color}`"
                      hide-details
                      class="mb-3"
                      v-on:change="changeLinkPage()"
                      v-model="filter.jenis_bidang"
                      item-text="name"
                      item-value="slug"
                      placeholder="Kategori / Jenis Dokumen"
                      solo
                      flat
                    ></v-autocomplete>

                    <v-autocomplete
                      :items="category_bidang"
                      :color="`${set_color}`"
                      :item-color="`${set_color}`"
                      hide-details
                      class="mb-3"
                      clearable
                      v-on:change="changeLinkPage()"
                      v-model="filter.category_bidang"
                      @click:clear="filter.category_bidang = ''; changeLinkPage()"
                      item-text="title"
                      item-value="slug"
                      placeholder="Bidang"
                      solo
                      flat
                    ></v-autocomplete>

                    <v-text-field
                      solo
                      flat
                      hide-details
                      clearable
                      class="mb-3"
                      v-on:keydown.enter.prevent="changeLinkPage()"
                      v-model="filter.nomor"
                      @click:clear="filter.nomor = ''; changeLinkPage()"
                      :color="`${set_color}`"
                      :placeholder="`Nomor`">
                    </v-text-field>

                    <v-autocomplete
                      :items="years"
                      :color="`${set_color}`"
                      :item-color="`${set_color}`"
                      hide-details
                      v-model="filter.tahun"
                      clearable
                      v-on:change="changeLinkPage()"
                      @click:clear="filter.tahun = ''; changeLinkPage()"
                      class="mb-3"
                      placeholder="Tahun"
                      solo
                      flat
                    ></v-autocomplete>

                    <!-- <v-text-field
                      solo
                      hide-details
                      clearable
                      type="number"
                      class="mb-4"
                      v-model="filter.tahun"
                      v-on:keydown.enter.prevent="changeLinkPage()"
                      @click:clear="filter.tahun = ''; changeLinkPage()"
                      :color="`${set_color}`"
                      :placeholder="`Tahun`">
                    </v-text-field> -->

                    <v-text-field
                      solo
                      flat
                      hide-details
                      clearable
                      class="mb-1"
                      v-model="filter.title"
                      v-on:change="changeLinkPage()"
                      v-on:keydown.enter.prevent="changeLinkPage()"
                      @click:clear="filter.title = ''; changeLinkPage()"
                      :color="`${set_color}`"
                      :placeholder="`Nama`">
                    </v-text-field>


                    <v-btn
                      elevation="0"
                      block
                      @click="changeLinkPage()"
                      @mouseover="voiceHover('Cari')"
                      height="36"
                      :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                      :color="`${set_color}`"
                      class="text-subtitle-2 text-capitalize font-weight-bold white--text mt-3 filter-sidebar__btn">

                      <v-icon size="18" class="mr-2">mdi-magnify</v-icon>
                      Cari
                    </v-btn>
                  </v-card-text>
                </v-card>

                <v-card flat class="filter-sidebar mt-4" v-if="$route.query.jenis === 'peraturan-desa'">
                  <v-card-text class="pa-5">
                    <div class="filter-sidebar__title">
                      <v-icon size="16" :color="set_color" class="mr-2">mdi-map-marker-radius</v-icon>
                      <span :style="`color: ${set_color}`">Filter Data Desa</span>
                    </div>
                    <v-autocomplete
                      :items="kecamatan"
                      :color="`${set_color}`"
                      :item-color="`${set_color}`"
                      hide-details
                      clearable
                      class="mb-3"
                      @click:clear="filter.kecamatan = ''; changeLinkPage()"
                      item-text="title"
                      item-value="title"
                      v-on:change="changeKecamatan(); changeLinkPage()"
                      v-model="filter.kecamatan"
                      placeholder="Kecamatan"
                      solo
                      flat
                    ></v-autocomplete>

                    <v-autocomplete
                      :items="desa"
                      :color="`${set_color}`"
                      :item-color="`${set_color}`"
                      hide-details
                      clearable
                      @click:clear="filter.desa = ''; changeLinkPage()"
                      :disabled="filter.kecamatan === '' || filter.kecamatan === null"
                      class="mb-1"
                      item-text="title"
                      item-value="title"
                      v-model="filter.desa"
                      placeholder="Desa/Kelurahan"
                      solo
                      flat
                    ></v-autocomplete>


                    <v-btn
                      elevation="0"
                      block
                      @click="changeLinkPage()"
                      height="36"
                      @mouseover="voiceHover('Cari')"
                      :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                      :color="`${set_color}`"
                      class="text-subtitle-2 text-capitalize font-weight-bold white--text mt-3 filter-sidebar__btn">

                      <v-icon size="20" class="mr-2">mdi-magnify</v-icon>
                      Cari
                    </v-btn>
                  </v-card-text>
                </v-card>

                <Sidebar />

              </v-col>
            </v-row>
          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  import moment from "moment"
  import "moment/locale/id"
  import axios from "axios";
  export default {
    middleware: false,
    data () {
      return {
        dialog: {
          filter: false
        },
        selected_filter: {
          category_bidang: false,
          title: false,
          tahun: false,
          nomor: false,
          jenis_bidang: false,
          kecamatan: false,
          desa: false
        },
        dateYear: false,
        list: [],
        unit: [],
        opd: [],
        kecamatan: [],
        desa: [],
        bidang: [
            {
              icon_url:require('@/assets/icon/education.png'),
              title: "Pendidikan",
              slug: "pendidikan"
            },
            {
              icon_url:require('@/assets/icon/budget.png'),
              title: "Keuangan",
              slug: "keuangan"
            },
            {
              icon_url:require('@/assets/icon/summer-holidays.png'),
              title: "Pariwisata",
              slug: "pariwisata"
            },
            {
              icon_url:require('@/assets/icon/folder (2).png'),
              title: "Kearsipan",
              slug: "kearsipan"
            },
            {
              icon_url:require('@/assets/icon/medical-result.png'),
              title: "Kesehatan",
              slug: "kesehatan"
            },
            {
              icon_url:require('@/assets/icon/infrastructure.png'),
              title: "Infrastruktur",
              slug: "infrastruktur"
            },
            {
              icon_url:require('@/assets/icon/education.png'),
              title: "Pendidikan",
              slug: "pendidikan"
            },
            {
              icon_url:require('@/assets/icon/budget.png'),
              title: "Keuangan",
              slug: "keuangan"
            },
            {
              icon_url:require('@/assets/icon/summer-holidays.png'),
              title: "Pariwisata",
              slug: "pariwisata"
            },
            {
              icon_url:require('@/assets/icon/folder (2).png'),
              title: "Kearsipan",
              slug: "kearsipan"
            },
            {
              icon_url:require('@/assets/icon/medical-result.png'),
              title: "Kesehatan",
              slug: "kesehatan"
            },
            {
              icon_url:require('@/assets/icon/infrastructure.png'),
              title: "Infrastruktur",
              slug: "infrastruktur"
            },
            {
              icon_url:require('@/assets/icon/education.png'),
              title: "Pendidikan",
              slug: "pendidikan"
            },
            {
              icon_url:require('@/assets/icon/budget.png'),
              title: "Keuangan",
              slug: "keuangan"
            },
            {
              icon_url:require('@/assets/icon/summer-holidays.png'),
              title: "Pariwisata",
              slug: "pariwisata"
            },
            {
              icon_url:require('@/assets/icon/folder (2).png'),
              title: "Kearsipan",
              slug: "kearsipan"
            },
            {
              icon_url:require('@/assets/icon/medical-result.png'),
              title: "Kesehatan",
              slug: "kesehatan"
            },
            {
              icon_url:require('@/assets/icon/infrastructure.png'),
              title: "Infrastruktur",
              slug: "infrastruktur"
            }
          ],
        category: [
          {
            name: "Semua Kategori",
            slug: "semua-kategori",
          }
        ],
        category_bidang: [],
        filter: {
          category_bidang: '',
          title: '',
          tahun: '',
          nomor: '',
          jenis_bidang: '',
          kecamatan: '',
          desa: ''
        },
        search: '',
        limit: 20,
        title: "",
        pagination: {
          total_data: 10,
          total_page: 5
        },
        process: {
          load: false,

          limit: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/page',
          title: 'Dokumen Hukum',
          description: 'Dokumen Hukum JDIH Setwan Kabupaten Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
      Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
    },
    watch: {
      'limit': function() {
        this.process.limit = true

        this.fetch('limit')
      },
      '$route.query.jenis': function(val) {
        this.changeLink(val)
      },
      '$route.query.category': function(val) {
        this.changeLink(val)
      },
      '$route.query.search': function(val) {
        this.changeLink(val)
      }
    },

    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        console.log(this.$store.state.header.config.color)
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      years () {
        let max = new Date().getFullYear(), min = max - 200, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
    },
    beforeMount () {
      // this.changeLink(this.$route.query.jenis)
    },
    mounted () {
      this.fetchCategory()
      this.fetchUnit()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
//       downloadFile(url, fileName) {
//   fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
//     .then(res => res.blob())
//     .then(res => {
//       const aElement = document.createElement('a');
//       aElement.setAttribute('download', fileName);
//       const href = URL.createObjectURL(res);
//       aElement.href = href;
//       aElement.setAttribute('target', '_blank');
//       aElement.click();
//       URL.revokeObjectURL(href);
//     });
// },
      async download (id) {

        this.process.form = true

        // SAVE TO REST API
        await this.$axios.$post(`${process.env.API}sites/doc/download`, {
          id: id
        })
        .then(response => {
          let res = response

          this.process.form = false

          if (res.status === 200) {
            this.fetch('download')
            // this.$emit('snackbar', res.message)
          } else {
            this.message.error = res.message
          }
        })

      },
      getFile(filePath) {
        if (!filePath || typeof filePath !== 'string') return '';
        return filePath.substr(filePath.lastIndexOf('\\') + 1).split('.')[3];
      },

      downloadFile(fileURL, fileName) {
        const link = document.createElement('a');
      link.href = fileURL;
      link.target = '_blank';
      link.download = fileName;

      // Simulate a click on the element <a>
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
        // fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
        //   .then(res => res.blob())
        //   .then(res => {
        //     // console.log(this.getFile(fileName).split('/')[5])
        //     const aElement = document.createElement('a');
        //     aElement.setAttribute('download', fileName);
        //     const href = URL.createObjectURL(res);
        //     aElement.href = href;
        //     aElement.setAttribute('target', '_blank');
        //     aElement.click();
        //     URL.revokeObjectURL(href);
        //   });
      },

      downloadFileAbstrak(fileURL, fileName) {
        const link = document.createElement('a');
      link.href = fileURL;
      link.target = '_blank';
      link.download = fileName;

      // Simulate a click on the element <a>
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
        // fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
        //   .then(res => res.blob())
        //   .then(res => {
        //     // console.log(this.getFile(fileName).split('/')[5])
        //     const aElement = document.createElement('a');
        //     aElement.setAttribute('download', fileName);
        //     const href = URL.createObjectURL(res);
        //     aElement.href = href;
        //     aElement.setAttribute('target', '_blank');
        //     aElement.click();
        //     URL.revokeObjectURL(href);
        //   });
      },

      async fetchCategory (id, type) {
        this.process.load = type === undefined ? true : false

        let params = {
          limit: 1000000,
          'title[nin]': 'Surat Keputusan,Surat Keputusan DPRD'
        }

        await this.$axios.$get(`${process.env.API}sites/doc/doc_type`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.category = [
              {
                name: "Semua Dokumen",
                slug: "semua-dokumen",
                id: ''
              }
            ]

            let selecCategory = []
            selecCategory = res.results.data.map(item => {
              const container = {};
              container.par_id = item.par_id;
              container.id = item.id
              container.name = item.title;
              container.slug = (item.title ? item.title.split(' ').join('-') : '').toLowerCase();
              return container
            })

            for (let i in selecCategory) {
              if(selecCategory[i].par_id !== '0') {
                this.category.push(
                  {
                    name: selecCategory[i].name,
                    id: selecCategory[i].id,
                    slug: selecCategory[i].slug
                  }
                )
              }

            }

            this.fetchCategoryBidang()

            // this.process.load = false
            this.changeLink()
          }
        })
      },
      async fetchCategoryBidang () {
        // this.process.load = true

        // let params = {
        //   limit: 10000,

        //   sort: 'DESC',

        //   cat_type: 'produk'
        // }

        await this.$axios.$get(`${process.env.API}sites/home/category`)
        .then(response => {
          let res = response

          this.process.load = false

          if (res.status === 200) {
            this.category_bidang = res.results.data.map(item => {
              const container = {};
              container.title = item.title;
              container.id = item.id
              container.icon_url = item.icon_url;
              container.slug = (item.title ? item.title.split(' ').join('-') : '').toLowerCase();
              return container
            })
          }
          this.filter.jenis_bidang = this.$route.query.jenis
          if (this.$route.query.category !== undefined && this.$route.query.category !== null) {
            this.filter.category_bidang = this.$route.query.category.split('-').join(' ')
            this.selected_filter= {
              category_bidang: this.filter.category_bidang === '' || this.filter.category_bidang === null ? false : true,
              title: this.filter.title === '' || this.filter.title === null ? false : true,
              tahun: this.filter.tahun === '' || this.filter.tahun === null ? false : true,
              nomor: this.filter.nomor === '' || this.filter.nomor === null ? false : true,
              jenis_bidang: this.filter.jenis_bidang === '' || this.filter.jenis_bidang === null ? false : true,
              kecamatan: this.filter.kecamatan === '' || this.filter.kecamatan === null ? false : true,
              desa: this.filter.desa === '' || this.filter.desa === null ? false : true
            }
          }

          // if () {

          // }
        })
      },
      async fetch (text) {
        this.process.load = this.process.limit || text !== undefined ? false : true

        let doc_type_title = this.filter.jenis_bidang === null || this.filter.jenis_bidang === '' || this.filter.jenis_bidang == 'semua-dokumen' ? '' : this.filter.jenis_bidang === 'e-risalah' ? 'e-risalah' : this.filter.jenis_bidang.split('-').join(' ')
        let doc_type_id = ''

        if (doc_type_title !== '') {
          const selectedDocType = this.category.find(item => (
            (item.slug && item.slug.toLowerCase() === this.filter.jenis_bidang.toLowerCase()) ||
            (item.name && item.name.toLowerCase() === doc_type_title.toLowerCase())
          ))

          doc_type_id = selectedDocType ? selectedDocType.id : ''
        }
        
        let params = {
          limit: this.limit,
          is_publish: 'Publish',

          doc_type_id: doc_type_id,
          category_title: this.filter.category_bidang === '' || this.filter.category_bidang === null ? '' : this.filter.category_bidang.split('-').join(' '),
          'title[lse]': this.filter.title,
          rule_number: this.filter.nomor,
          tahun: this.filter.tahun === null ? '' : this.filter.tahun,
          kecamatan_name: this.filter.kecamatan === null ? '' : this.filter.kecamatan,
          desa_name: this.filter.desa === null ? '' : this.filter.desa
        }

        // Add doc_type_title[nin] only if doc_type_title is empty
        if (doc_type_title === '' || doc_type_title === null) {
          params['doc_type_title[nin]'] = 'Surat Keputusan,Surat Keputusan DPRD'
        }

        await this.$axios.$get(`${process.env.API}sites/doc/data`, { params })
        .then(response => {
          let res = response


          this.process.limit = false

          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination

          }
          this.process.list = false
          this.process.load = false

        })
      },
      async fetchUnit() {
        //  this.process.load = true

         let params = {
          limit: 10000000000000
        }

        await this.$axios.$get(`https://api.klaten.go.id/sites/profile/unit`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.unit = res.results.data
            this.fetchOPD()
          }
        })
      },
      async fetchOPD() {
        //  this.process.load = true

         let params = {
          limit: 10000000000000,
          type: "OPD"
        }

        await this.$axios.$get(`https://api.klaten.go.id/sites/profile/unit`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.opd = res.results.data
            this.fetchKecamatan()
          }
        })
      },
      async fetchKecamatan() {
        //  this.process.load = true

         let params = {
          limit: 10000000000000,
          type: "Kecamatan"
        }

        await this.$axios.$get(`https://api.klaten.go.id/sites/profile/unit`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.kecamatan = res.results.data
            // this.process.load = false
          }
        })
      },
      changeKecamatan () {
        let par_id = ''
        this.kecamatan.map(obj => {
          if (obj.title === this.filter.kecamatan) {
            par_id = obj.id
          }
        })

        this.desa = []

        for(let i in this.unit) {
          if (this.unit[i].par_id === par_id) {
            this.desa.push(this.unit[i])
          }
        }
      },
      async download_abstrak (item) {

        this.process.form = true

        await axios({
          url: `${process.env.API}sites/doc/download_abstrak`,
          method: 'POST',
          responseType: 'blob', // important,
          data: {
            id: item.id
          },
          // headers: {
          //   Authorization: process.env.API_SECRET,
          //   token: this.store.state.member.auth.token
          // }
        }).then((response) => {
          let res = response

          // console.log(response)

          // if (res.status === 200) {
            this.process.form = false

            // this.dialog.success = true
            // this.message.success = 'Berhasil mengeksport data'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', `Abstrak-${(item.title ? item.title.split(' ').join('-').split('/').join('-') : 'document')}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
            document.body.appendChild(link)
            link.click()
          // } else {
          //   this.process.print = false
          //   this.message.error = res.message
          // }
        })

        // SAVE TO REST API
        // await this.$axios.$post(`${process.env.API}sites/doc/download_abstrak`, {
        //   id: item.id
        // })
        // .then(response => {
        //   let res = response

        //   this.process.form = false

        //   const url = window.URL.createObjectURL(new Blob([response]))
        //   const link = document.createElement('a')
        //   link.href = url
        //   link.setAttribute('download', `Abstrak-${(item.title.split(' ').join('-').split('/').join('-'))}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
        //   document.body.appendChild(link)
        //   link.click()
        //   if (res.status === 200) {
        //     // this.$emit('snackbar', res.message)
        //     // this.fetchDetail()
        //   } else {
        //     this.message.error = res.message
        //   }
        // })

      },
      changeLink(query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        this.category = this.category.map(item => {
          const container = {};

          container.name = item.name;
          container.slug = (item.name ? item.name.split(' ').join('-') : '').toLowerCase();
          container.id = item.id

          // this.category = container;
          return container
        })

        this.filter.jenis_bidang = this.$route.query.jenis === undefined ? this.category[0].slug : this.$route.query.jenis
        this.filter.category_bidang = this.$route.query.category === null || this.$route.query.category === undefined ? '' : this.$route.query.category
        this.filter.title = this.$route.query.title === undefined ? '' : this.$route.query.title
        this.filter.tahun = this.$route.query.tahun === undefined ? '' : this.$route.query.tahun*1
        this.filter.nomor = this.$route.query.nomor === undefined ? '' : this.$route.query.nomor
        this.search = this.$route.query.search === undefined ? '' : this.$route.query.search

        this.selected_filter= {
          category_bidang: this.filter.category_bidang === '' || this.filter.category_bidang === null ? false : true,
          title: this.filter.title === '' || this.filter.title === null ? false : true,
          tahun: this.filter.tahun === '' || this.filter.tahun === null ? false : true,
          nomor: this.filter.nomor === '' || this.filter.nomor === null ? false : true,
          jenis_bidang: this.filter.jenis_bidang === '' || this.filter.jenis_bidang === null ? false : true,
          kecamatan: this.filter.kecamatan === '' || this.filter.kecamatan === null ? false : true,
          desa: this.filter.desa === '' || this.filter.desa === null ? false : true
        }

        let status = false
        let id = ''

        if (this.$route.query.jenis !== undefined) {
          for(let i = 0; i < this.category.length; i++){
            if (this.category[i].slug === this.$route.query.jenis) {
              this.filter.jenis_bidang = this.category[i].slug
              status = true
            } else {
              // status = false
            }
          }
          // this.filter.jenis_bidang = this.filter.jenis_bidang === '' ? this.$route.query.jenis : this.filter.jenis_bidang
          // if (query === 'wisata') {
          //     this.selected = {
          //       category: 0,
          //     }
          // } else if (query === 'kuliner') {
          //   this.selected = {
          //     category: 1
          //   }
          // }
          // this.fetch(id)
        }
        // console.log(status)
        if (this.$route.query.search === undefined || this.$route.query.jenis === undefined || this.$route.query.category === undefined || this.$route.query.tahun === undefined || this.$route.query.nomor === undefined || this.$route.query.title === undefined) {
          this.$router.replace({'path': '/page', 'query': {'jenis': this.filter.jenis_bidang, 'search': this.search, 'category': this.filter.category_bidang, 'tahun': this.filter.tahun, 'nomor': this.filter.nomor, 'title': this.filter.title}})
          // if(this.$route.query.search === undefined) {
          //   if (this.$route.query.category === undefined) {
          //     this.$router.replace({'path': '/page', 'query': {'jenis': this.category[0].slug}})
          //   } else {
          //     this.$router.replace({'path': '/page', 'query': {'jenis': this.category[0].slug, 'category': this.$route.query.category}})
          //   }
          // } else {
          //   if (this.$route.query.category === undefined) {
          //     this.$router.replace({'path': '/page', 'query': {'jenis': this.category[0].slug, 'search': this.$route.query.search }})
          //   } else {
          //     this.$router.replace({'path': '/page', 'query': {'jenis': this.category[0].slug, 'search': this.$route.query.search , 'category': this.$route.query.category}})
          //   }
          // }
          // this.$router.push(`/page?jenis=${this.category[0].slug}`)
        }
        // this.filter.jenis_bidang = this.$route.query.jenis === undefined ? this.category[0].slug : this.$route.query.jenis

        // if (this.$route.query.jenis !== this.filter.jenis_bidang) {
        //   if(this.$route.query.search === undefined) {
        //     if (this.$route.query.category === undefined) {
        //       this.$router.replace({'path': '/page', 'query': {'jenis': this.filter.jenis_bidang}})
        //     } else {
        //       this.$router.replace({'path': '/page', 'query': {'jenis': this.filter.jenis_bidang, 'category': this.$route.query.category}})
        //     }
        //   } else {
        //     if (this.$route.query.category === undefined) {
        //       this.$router.replace({'path': '/page', 'query': {'jenis': this.filter.jenis_bidang, 'search': this.$route.query.search }})
        //     } else {
        //       this.$router.replace({'path': '/page', 'query': {'jenis': this.filter.jenis_bidang, 'search': this.$route.query.search , 'category': this.$route.query.category}})
        //     }
        //   }
        // }

        // console.log(id)

        this.fetch()
      },
      changeLinkPage(query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        console.log(this.filter.title)

        this.selected_filter= {
          category_bidang: this.filter.category_bidang === '' || this.filter.category_bidang === null ? false : true,
          title: this.filter.title === '' || this.filter.title === null ? false : true,
          tahun: this.filter.tahun === '' || this.filter.tahun === null ? false : true,
          nomor: this.filter.nomor === '' || this.filter.nomor === null ? false : true,
          jenis_bidang: this.filter.jenis_bidang === '' || this.filter.jenis_bidang === null ? false : true,
          kecamatan: this.filter.kecamatan === '' || this.filter.kecamatan === null ? false : true,
          desa: this.filter.desa === '' || this.filter.desa === null ? false : true
        }

        this.$router.replace({'path': '/page', 'query': {'jenis': this.filter.jenis_bidang, 'search': this.search, 'category': this.filter.category_bidang, 'tahun': this.filter.tahun, 'nomor': this.filter.nomor, 'title': this.filter.title}})


        // console.log(id)

        this.fetch()
      },
      toDetail(item) {
        if (!item || !item.title) return;
        this.$router.push(`/page/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      },
      changeFilterLink() {
        // if (this.$route.query.search !== undefined) {
        //   this.$router.replace({'path': '/page', 'query': {'jenis': this.$route.query.jenis, 'search': this.$route.query.search }})

        // } else {
        //   this.$router.replace({'path': '/page', 'query': {'jenis': this.$route.query.jenis}})

        // }
        // this.filter.category_bidang = ''
        // this.changeLink()
      }
    }
  }
</script>

<style scoped>
.doc-page {
  background-color: #F7F8FA;
}

/* Header */
.doc-header {
  margin-bottom: 18px;
  padding: 20px 22px;
  border: 1px solid #E7ECF2;
  border-radius: 16px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 251, 253, 0.98) 100%);
}
.doc-header__topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 2px;
}
.doc-header__eyebrow {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.85;
}
.doc-header__main {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.doc-header__title-wrap {
  min-width: 0;
}
.doc-header__title {
  font-weight: 700;
  color: #1D232A;
  line-height: 1.15;
  letter-spacing: -0.02em;
  text-transform: capitalize;
}
.doc-header__title--lg {
  font-size: 20px;
}
.doc-header__title--sm {
  font-size: 18px;
}
.doc-header__subtitle {
  margin-top: 8px;
  color: #66707C;
  font-size: 13.5px;
  line-height: 1.55;
  max-width: 560px;
}
.doc-header__meta {
  flex: none;
}
.doc-header__count {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid #E2E8F0;
  border-radius: 999px;
  background: #FFFFFF;
  color: #475467;
  display: inline-flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
}
.doc-filter-trigger {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #D7E1ED;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #475467;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 600;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.doc-filter-trigger:hover {
  background: #FFFFFF;
  border-color: #C8D6E5;
  transform: translateY(-1px);
}
.doc-filter-trigger:focus,
.doc-filter-trigger:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(46, 125, 225, 0.14);
}

/* Document card */
.doc-card {
  background: #FFFFFF;
  border: 1px solid #E7E9EC;
  border-radius: 10px;
  margin-bottom: 12px;
  padding: 16px 18px;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.doc-card:hover {
  box-shadow: 0 4px 16px rgba(20, 22, 25, 0.06);
}
.doc-card__row {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}
.doc-card__icon {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}
.doc-card__body {
  min-width: 0;
  flex: 1;
}
.doc-card__title-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.doc-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #1F2328;
  line-height: 1.4;
  flex: 1;
}
.doc-card__status {
  flex: none;
  font-size: 10.5px !important;
  letter-spacing: 0.02em;
  border-radius: 5px !important;
  height: 22px !important;
}
.doc-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
  margin-top: 8px;
}
.doc-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12.5px;
  color: #71767D;
  white-space: nowrap;
}
.doc-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #F0F1F3;
}
.doc-card__btn {
  border-radius: 7px !important;
  letter-spacing: 0.01em;
}

/* Filter sidebar */
.filter-sidebar {
  border: 1px solid #E7E9EC !important;
  border-radius: 10px !important;
}
.filter-sidebar__title {
  display: flex;
  align-items: center;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 14px;
}
.filter-sidebar__btn {
  border-radius: 8px !important;
}
.filter-sidebar >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F4F5F7 !important;
  box-shadow: none !important;
  min-height: 42px !important;
}
.filter-sidebar >>> .v-text-field--solo > .v-input__control > .v-input__slot,
.filter-sidebar >>> .v-select.v-text-field--solo > .v-input__control > .v-input__slot,
.filter-sidebar >>> .v-autocomplete.v-text-field--solo > .v-input__control > .v-input__slot {
  min-height: 42px !important;
}
.filter-sidebar >>> .v-text-field__slot input {
  font-size: 13px !important;
}
.filter-sidebar >>> .v-select__slot,
.filter-sidebar >>> .v-text-field__slot {
  font-size: 13px !important;
}
.filter-sidebar >>> .v-select__selection,
.filter-sidebar >>> .v-select__selections,
.filter-sidebar >>> .v-select__slot input,
.filter-sidebar >>> .v-text-field__slot input::placeholder {
  font-size: 13px !important;
}
.filter-sidebar >>> .v-input__append-inner,
.filter-sidebar >>> .v-input__prepend-inner {
  margin-top: 9px !important;
}

/* Filter dialog (mobile) */
.filter-dialog {
  border-radius: 10px !important;
}
.filter-dialog__header {
  border-bottom: 1px solid #F0F1F3;
}
.filter-dialog__title {
  font-size: 15px;
  font-weight: 700;
  color: #22262B;
}
.filter-dialog >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F4F5F7 !important;
  box-shadow: none !important;
}

@media (max-width: 1300px) {
  .doc-card {
    padding: 14px;
  }
}
@media (max-width: 900px) {
  .doc-header {
    padding: 18px 16px;
    border-radius: 14px;
  }
  .doc-header__main {
    flex-direction: column;
    align-items: flex-start;
  }
  .doc-header__subtitle {
    max-width: none;
  }
}
</style>

<style>
.v-list-item--link:before {
    background-color: transparent !important;
}
</style>